module.exports = __webpack_public_path__ + "static/media/icon-customer-login.42893620.svg";